import {
  ReviewerProductivity,
  ReviewerProgressFilterDataRPW,
  ReviewProductivityRequest,
  ReviewTagCount,
} from '../../components/dashboard/dashboardTypes';
import BASE_URL from '../../config/env';
import {apiClient} from '../apiClient';

const projectManagementDashboardEndpoint = (path: string) =>
  `${BASE_URL}/projectmanagement/api/v1/dashboard${path}`;

const assignmentEndpoint = (path: string) =>
  `assignments/api/v1/assignment${path}`;

const domainAdminDashboardEndpoint = (path: string) =>
  `projectmanagement/api/v1/domaindashboard${path}`;

export const getReviewDashboardData = async (payload = {}) => {
  const {data} = await apiClient.post(
    projectManagementDashboardEndpoint('/dashboard'),
    payload
  );
  return data;
};
export const getReviewManagerList = async () => {
  const {data} = await apiClient.get(
    projectManagementDashboardEndpoint(`reviewdashboard/review-dashboard`)
  );
  return data;
};

export const getReviewRateList = async (isDefault: boolean) => {
  const {data} = await apiClient.get(
    projectManagementDashboardEndpoint(
      `/review-rate${isDefault ? '/default' : ''}`
    )
  );
  return data;
};

export const getReviewProgress = async (payload = {}) => {
  const {data} = await apiClient.post(
    projectManagementDashboardEndpoint(`/review-progress`),
    payload
  );
  return data;
};

export const getTaggingWidgetData = async (payload: ReviewTagCount) => {
  const {data} = await apiClient.post(
    projectManagementDashboardEndpoint(`/tag-classifications/details`),
    payload
  );
  return data;
};

export const getReviewerProductivityData = async (
  payload: ReviewerProductivity
) => {
  const {data} = await apiClient.post(
    projectManagementDashboardEndpoint(`/reviewer-productivity`),
    payload
  );
  return data;
};

export const getEndToEnd = async () => {
  const {data} = await apiClient.get(
    projectManagementDashboardEndpoint(`/end-to-end`)
  );
  return data;
};

export const getTagClassificationDetails = async () => {
  const {data} = await apiClient.get(
    projectManagementDashboardEndpoint(`/tag-classifications/details`)
  );
  return data;
};

export const getWidgetsList = async () => {
  const {data} = await apiClient.get(
    projectManagementDashboardEndpoint(`/widgets`)
  );
  return data;
};

export const getReviewGridData = async () => {
  const {data} = await apiClient.get(
    `projectmanagement/api/v1/reviewdashboard/review-dashboard`
  );
  return data;
};

export const saveWidgetData = async (payload = {}) => {
  const {data} = await apiClient.post(
    projectManagementDashboardEndpoint(`/widgets`),
    payload
  );
  return data;
};

export const saveWidgetSequence = async (payload = {}) => {
  const {data} = await apiClient.put(
    projectManagementDashboardEndpoint(`/widgets/sequence`),
    payload
  );
  return data;
};

export const getTagTreeData = async () => {
  const {data} = await apiClient.get(
    projectManagementDashboardEndpoint(`/tag-tree`)
  );
  return data;
};

export const getActiveProjectsData = async (entityId: number) => {
  const {data} = await apiClient.get(
    domainAdminDashboardEndpoint(
      `/projects/details?entityId=${entityId}&isActive=true`
    )
  );
  return data;
};

export const getReviewerList = async () => {
  const {data} = await apiClient.get(
    projectManagementDashboardEndpoint(`/reviewers`)
  );
  return data;
};

export const getActiveProjectsUtilization = async (entityId: number) => {
  const {data} = await apiClient.get(
    domainAdminDashboardEndpoint(`/domain-dashboard/utilization/${entityId}`)
  );
  return data;
};

export const getUsersInActiveProjects = async (entityId: number) => {
  const {data} = await apiClient.get(
    domainAdminDashboardEndpoint(
      `/users/details?entityId=${entityId}&isActive=true`
    )
  );
  return data;
};

export const getDomainAdminGridConfig = async () => {
  const {data} = await apiClient.get(
    domainAdminDashboardEndpoint(`/domain-dashboard`)
  );
  return data;
};

export const getDomainAdminGridData = async (queryParams: {
  projectLabel: string;
  pageSize: number;
  pageNumber: number;
  sortingOrder: string;
  sortingColumn: string;
  isActive: boolean;
  entityId?: number;
}) => {
  const {
    projectLabel,
    pageSize,
    pageNumber,
    sortingOrder,
    sortingColumn,
    isActive,
    entityId,
  } = queryParams;
  const {data} = await apiClient.get(
    domainAdminDashboardEndpoint(
      `/loadgrid?entityId=${entityId}&isActive=${isActive}&projectLabel=${projectLabel}&pageSize=${pageSize}&pageNumber=${pageNumber}&sortingOrder=${sortingOrder}&sortingColumn=${sortingColumn}`
    )
  );
  return data;
};

export const setRoleToRMU = async (payload: {projectId: number}) => {
  const {data} = await apiClient.post(
    domainAdminDashboardEndpoint(`/change-role`),
    payload
  );
  return data;
};

export const deactivateProject = async (payload: {
  projectId: number;
  entityId?: number;
}) => {
  const {data} = await apiClient.post(
    domainAdminDashboardEndpoint(
      `/projects/deactivate?entityId=${payload.entityId}&role=-2&projectId=${payload.projectId}`
    )
  );
  return data;
};

export const exportToExcel = async (payload: string) => {
  const {data} = await apiClient.post(
    domainAdminDashboardEndpoint(
      `/report/export?requestData=${encodeURIComponent(payload)}`
    )
  );
  return data;
};

export const saveColumnDetails = async (payload: {
  IsAscending: string;
  IsProjectActive: boolean;
  SelectedCustomColumns: string[];
  SortingColumn: string;
}) => {
  const {data} = await apiClient.post(
    domainAdminDashboardEndpoint(`/grid-columns`),
    payload
  );
  return data;
};

export const getTagClassifications = async () => {
  const {data} = await apiClient.get(
    projectManagementDashboardEndpoint(`/tag-classifications`)
  );
  return data;
};

export const getRedactionTag = async () => {
  const {data} = await apiClient.get(
    projectManagementDashboardEndpoint(`/redaction-tag`)
  );
  return data;
};

export const saveReviewerProductivityData = async (
  payload: ReviewProductivityRequest
) => {
  const {data} = await apiClient.post(
    projectManagementDashboardEndpoint('/reviewer-productivity'),
    payload
  );
  return data;
};

export const saveReviewProgress = async (
  payload: ReviewerProgressFilterDataRPW
) => {
  const {data} = await apiClient.post(
    projectManagementDashboardEndpoint(`/review-progress`),
    payload
  );
  return data;
};
export const deleteWidget = async (widgetId: number) => {
  const {data} = await apiClient.delete(
    projectManagementDashboardEndpoint(`/widgets?widgetId=${widgetId}`)
  );
  return data;
};

export const drawAssignmentFromPool = async (assignmentId: number) => {
  const {data} = await apiClient.get(
    assignmentEndpoint(`/documents/draw?assignmentId=${assignmentId}`)
  );
  return data;
};

export const getAllProjectsData = async () => {
  const {data} = await apiClient.get(domainAdminDashboardEndpoint(`/header`));
  return data;
};

export const getMenusData = async () => {
  const {data} = await apiClient.get(
    projectManagementDashboardEndpoint(`/menu`)
  );
  return data;
};

export const getDomainDashboardReport = async (reportId: number | string) => {
  const {data} = await apiClient.get(
    domainAdminDashboardEndpoint(`/report?reportId=${reportId}`),
    {responseType: 'blob'}
  );
  return data;
};
